import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QUERY_CONFIG } from "../core/config/Constant";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 2 minutes — no refetch within this window
      staleTime: QUERY_CONFIG.STALE_TIME_2_MINUTES,
      // Don't refetch just because the user switches browser tabs
      refetchOnWindowFocus: false,
      // Refetch on mount only if data is stale (respects staleTime above)
      refetchOnMount: true,
    },
  },
});

function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default QueryProvider;
